/* Kick Frame — productdetails als opstellingsbriefje uit een wedstrijdprogramma: genummerde
   regels (formaat, afwerking, papier, druk, levering, retour) met gouden nummers.
   Formaat en afwerking lopen live mee met de keuze in het productformulier. */
(function () {
  var form = document.querySelector('[data-product-form]');
  var detail = document.querySelector('.product-detail');
  if (!form || !detail) return;
  var radios = [].slice.call(form.querySelectorAll('input[type=radio][data-option-position]'));
  var sizeRadios = radios.filter(function (r) { return /^A\d\b/.test(r.value); });
  if (!sizeRadios.length) return;   // geen posterformaten (bijv. cadeaubon): niets tonen
  var finishRadios = radios.filter(function (r) { return sizeRadios.indexOf(r) < 0; });
  var title = (detail.querySelector('h1') || {}).textContent || '';

  var css = ''
    + '.kf-prog{margin:1.6rem 0 1.2rem;border:1px solid rgba(214,178,94,.32);border-radius:14px;overflow:hidden;'
    + 'background:linear-gradient(160deg,#152b21 0%,#0f2018 100%)}'
    + '.kf-prog-head{display:flex;justify-content:space-between;align-items:flex-end;gap:1rem;padding:1rem 1.2rem .85rem;'
    + 'border-bottom:2px solid var(--gold,#d6b25e)}'
    + '.kf-prog-kicker{display:block;font:700 .64rem/1 Inter,system-ui,sans-serif;letter-spacing:.2em;text-transform:uppercase;color:var(--gold,#d6b25e);margin-bottom:.45rem}'
    + '.kf-prog-title{display:block;font:600 1.2rem/1.15 Fraunces,Georgia,serif;color:#f4efe2}'
    + '.kf-prog-badge{flex:0 0 auto;font:700 .62rem/1 Inter,system-ui,sans-serif;letter-spacing:.16em;text-transform:uppercase;'
    + 'color:#0c1511;background:var(--gold,#d6b25e);padding:.4rem .55rem;border-radius:4px}'
    + '.kf-prog ol{list-style:none;margin:0;padding:.35rem 1.2rem .5rem}'
    + '.kf-prog li{display:grid;grid-template-columns:2rem auto 1fr auto;align-items:baseline;gap:.6rem;padding:.6rem 0;'
    + 'border-bottom:1px solid rgba(244,239,226,.08)}'
    + '.kf-prog li:last-child{border-bottom:0}'
    + '.kf-prog-no{font:600 1rem/1 Fraunces,Georgia,serif;color:var(--gold,#d6b25e)}'
    + '.kf-prog-label{font:600 .68rem/1.2 Inter,system-ui,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:rgba(244,239,226,.6)}'
    + '.kf-prog-dots{border-bottom:1px dotted rgba(244,239,226,.22);transform:translateY(-.2rem)}'
    + '.kf-prog-value{font:500 .92rem/1.3 Inter,system-ui,sans-serif;color:#f4efe2;text-align:right}'
    + '.kf-prog-foot{display:flex;justify-content:space-between;padding:.7rem 1.2rem;border-top:1px dashed rgba(214,178,94,.35);'
    + 'font:600 .6rem/1 Inter,system-ui,sans-serif;letter-spacing:.18em;text-transform:uppercase;color:rgba(244,239,226,.45)}'
    + '@media (max-width:38rem){.kf-prog li{grid-template-columns:1.7rem 1fr auto}.kf-prog-dots{display:none}.kf-prog-value{font-size:.86rem}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  // tekst uit het label van een keuzerondje, zonder prijs: "Unframed · Shipped in a tube"
  function labelText(r) {
    var l = form.querySelector('label[for="' + r.id + '"]');
    if (!l) return r.value;
    var parts = l.innerText.split('\n').map(function (s) { return s.trim(); })
      .filter(function (s) { return s && !/[€$£]\s?\d/.test(s) && !/^·?\s*popular$/i.test(s); });
    return parts.slice(0, 2).join(' · ').replace(/\s*·\s*popular/i, '');
  }
  function checked(list) { for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i]; return list[0]; }

  var rows = [
    ['Size', function () { return labelText(checked(sizeRadios)); }],
    ['Finish', finishRadios.length ? function () { return labelText(checked(finishRadios)); } : null],
    ['Paper', '170 gsm semi-gloss, FSC'],
    ['Print', 'Printed locally, close to you'],
    ['Kick-off', 'Free delivery in 2–4 days'],
    ['Returns', '14 days after receipt']
  ].filter(function (r) { return r[1]; });

  var box = document.createElement('section');
  box.className = 'kf-prog';
  box.setAttribute('aria-label', 'Poster details');
  var html = '<div class="kf-prog-head"><div><span class="kf-prog-kicker">Match programme</span>'
    + '<span class="kf-prog-title"></span></div><span class="kf-prog-badge">Team sheet</span></div><ol>';
  rows.forEach(function (r, i) {
    html += '<li><span class="kf-prog-no">' + (i < 9 ? '0' : '') + (i + 1) + '</span>'
      + '<span class="kf-prog-label">' + r[0] + '</span><span class="kf-prog-dots" aria-hidden="true"></span>'
      + '<span class="kf-prog-value" data-row="' + i + '"></span></li>';
  });
  html += '</ol><div class="kf-prog-foot" aria-hidden="true"><span>Kick Frame</span><span>Football posters</span></div>';
  box.innerHTML = html;
  box.querySelector('.kf-prog-title').textContent = title.trim();

  function fill() {
    rows.forEach(function (r, i) {
      box.querySelector('[data-row="' + i + '"]').textContent = typeof r[1] === 'function' ? r[1]() : r[1];
    });
  }
  fill();
  form.addEventListener('change', fill);

  var acc = detail.querySelector('.accordion');
  if (acc) detail.insertBefore(box, acc); else detail.appendChild(box);
})();
